import request from "@/utils/request";

/**
 *  登录
 * @param {*} data
 * @returns
 */
export function fetchCompleteHospital(params) {
  return request({
    url: "/api/hospital",
    method: "get",
    params,
  });
}
